import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem } from '@/components/ui/command';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Check } from 'lucide-react';
import { countries } from '@/data/countries';

export const CountrySelect = ({ value, onChange, placeholder = "Select country..." }) => {
  const [open, setOpen] = useState(false);

  const selectedCountry = countries.find(c => c.name === value || c.code === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-full justify-between bg-background text-foreground border-border h-16 text-base"
        >
          {selectedCountry ? (
            <span className="flex items-center gap-2">
              <span className="text-2xl">{selectedCountry.flag}</span>
              {selectedCountry.name}
            </span>
          ) : (
            <span className="text-muted-foreground">{placeholder}</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-full p-0 bg-popover text-popover-foreground border-border">
        <Command className="bg-popover text-popover-foreground">
          <CommandInput placeholder="Search country..." className="text-foreground" />
          <CommandEmpty>No country found.</CommandEmpty>
          <CommandGroup style={{ maxHeight: '300px', overflowY: 'auto' }}>
            {countries.map((country) => (
              <CommandItem
                key={country.code}
                value={country.name}
                onSelect={() => {
                  onChange(country.name);
                  setOpen(false);
                }}
                className="text-foreground cursor-pointer"
              >
                <Check
                  className={`mr-2 h-4 w-4 ${
                    value === country.name ? "opacity-100" : "opacity-0"
                  }`}
                />
                <span className="text-2xl mr-2">{country.flag}</span>
                {country.name}
              </CommandItem>
            ))}
          </CommandGroup>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
